export type SectionId =
  | "dashboard"
  | "tim"
  | "chat"
  | "organizacije"
  | "odluke"
  | "postavke";

export interface Section {
  id: SectionId;
  panels: string[];
}

export interface MenuContext {
  isOrgOwner: boolean;
  workAvailable: boolean;
  pilotAvailable: boolean;
  chatAvailable?: boolean;
}

export const SECTION_LABELS: Record<SectionId, { hr: string; en: string }> = {
  dashboard: { hr: "Dashboard", en: "Dashboard" },
  tim: { hr: "Tim", en: "Team" },
  chat: { hr: "Chat", en: "Chat" },
  organizacije: { hr: "Organizacije", en: "Organizations" },
  odluke: { hr: "Odluke", en: "Decisions" },
  postavke: { hr: "Postavke", en: "Settings" },
};

function buildSections({ isOrgOwner, workAvailable, pilotAvailable, chatAvailable }: MenuContext): Section[] {
  const dashboard: string[] = ["overview"];
  if (pilotAvailable) dashboard.push("pilot");

  const tim: string[] = [];
  if (workAvailable) tim.push("work");
  tim.push("jobs", "research");

  const chat: string[] = [];
  if (chatAvailable ?? workAvailable) chat.push("coordinator");

  const organizacije: string[] = isOrgOwner ? ["leads", "opportunity", "business"] : ["opportunity", "business"];

  const odluke: string[] = ["approvals"];

  const postavke: string[] = ["session"];
  if (isOrgOwner) postavke.push("integrations");
  postavke.push("budget", "audit", "governance", "guide");

  return [
    { id: "dashboard", panels: dashboard },
    { id: "tim", panels: tim },
    { id: "chat", panels: chat },
    { id: "organizacije", panels: organizacije },
    { id: "odluke", panels: odluke },
    { id: "postavke", panels: postavke },
  ].filter((section) => section.panels.length > 0) as Section[];
}

export function menuFor(context: MenuContext): Section[] {
  return buildSections(context);
}

export function sectionOf(panel: string, sections: Section[]): SectionId | undefined {
  for (const section of sections) {
    if (section.panels.includes(panel)) return section.id;
  }
  return undefined;
}
